import type { ComponentType } from 'react'
import type { MagnitudeInputProps } from './contract'
import { Dial } from './Dial'
import { BandPad } from './BandPad'

export type InputMethodId = 'dial' | 'pad'

export const INPUT_METHODS: { id: InputMethodId; name: string; desc: string; component: ComponentType<MagnitudeInputProps> }[] = [
  { id: 'dial', name: 'Power dial', desc: 'Rotary dial with band jump buttons (default)', component: Dial },
  { id: 'pad', name: 'Band pad', desc: 'Tap a band, then ×1 / ×10 / ×100 — no gestures', component: BandPad },
]

export function getInputMethod(): InputMethodId {
  const v = localStorage.getItem('wayoff.input')
  return v === 'pad' ? 'pad' : 'dial'
}
export function setInputMethod(id: InputMethodId) { localStorage.setItem('wayoff.input', id) }
